import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { PAGE_METADATA_KEYS } from 'shared/constants';
import { GET_PAGE_EDITOR } from './pageEditorCache';

/** The page as the editor holds it: every page has a schema metadata field, empty if unset. */
export const withSchemaMeta = (page) => {
  if (page?.metadata && !page.metadata.find(meta => meta.key === PAGE_METADATA_KEYS.SCHEMA)) {
    return { ...page, metadata: [...page.metadata, { key: PAGE_METADATA_KEYS.SCHEMA, value: '' }] };
  }
  return page;
};

const useGetPage = ({ id }) => {
  // Always from the server when the editor opens: a cached copy from an earlier visit may predate
  // someone else's save, and the first save would then hit the conflict banner.
  const { data, loading } = useQuery(GET_PAGE_EDITOR, {
    variables: { id },
    fetchPolicy: 'network-only'
  });

  const [page, setPage] = useState(null);

  useEffect(() => {
    setPage(withSchemaMeta(data?.page));
  }, [data]);

  return {
    page: page,
    templates: data?.templates,
    widgetPresets: data?.widgetPresets,
    isFetching: loading
  };
};

export default useGetPage;
